export const COLORS = {
  backgroundGreen: 'rgba(36, 180, 126, 1)',
  backgroundOffsetOnLight: 'rgba(245, 246, 248, 1)',
  borderOnLight: 'rgba(26, 26, 26, 0.1)',
  borderSelected: 'rgba(23, 23, 23, 1)',
  borderSubduedOnLight: 'rgba(26, 26, 26, 0.05)',
  defaultBackgroundColor: '#ffffff',
  defaultButtonColor: '#0074d4',
  offsetOnLight: 'rgba(26, 26, 26, 0.04)',
  offsetHoverOnLight: 'rgba(26, 26, 26, 0.08)',
  textDisabled: 'rgba(26, 26, 26, 0.5)',
  textDisabledOnDark: 'rgba(255, 255, 255, 0.5)',
  textDisabledOnLight: 'rgba(26, 26, 26, 0.5)',
  textPrimary: 'rgba(26, 26, 26, 1)',
  textPrimaryOnDark: 'rgba(255, 255, 255, 1)',
  textSecondary: 'rgba(64, 64, 64, 1)',
  textSubduedOnDark: 'rgba(255, 255, 255, 0.7)',
  textSubduedOnLight: 'rgba(26, 26, 26, 0.7)',
  errorBackground: 'rgba(220, 39, 39, 0.04)',
  communicationCritical: 'rgba(220, 39, 39, 1)',
  textFeedbackSuccess: '#217005',
  warningBackground: 'rgba(254, 251, 231, 1)',
  communicationWarning: 'rgba(187, 85, 4, 1)',
};
